function toggleFilters() {
    const sidebar = document.querySelector('.VarCol-custom-sidebar-filters');
    sidebar.classList.toggle('active');
    document.body.classList.toggle('VarCol-no-scroll'); // Disable background scroll
}

document.addEventListener('click', function(event) {
    const sidebar = document.querySelector('.VarCol-custom-sidebar-filters');
    if (sidebar.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'auto';
    }
});

function updateDuctlessCounts() {
    const items = document.querySelectorAll('.VarCol-variant-collection-item');
    let yesCount = 0;
    let noCount = 0;

    items.forEach(item => {
        const isDuctless = item.getAttribute('data-ductless');
        if (isDuctless === "Yes") {
            yesCount++;
        } else if (isDuctless === "No") {
            noCount++;
        }
    });

    document.getElementById('ductless-yes-count').textContent = `(${yesCount})`;
    document.getElementById('ductless-no-count').textContent = `(${noCount})`;
}

function VarColApplyFilters() {
    // Get selected CFM ranges
    const selectedCFMs = Array.from(document.querySelectorAll('.VarCol-filter-cfm:checked')).map(input => input.value);

    // Check if Ductless, Outdoors, and Fast Shipping checkboxes are selected
    const ductlessSelected = document.querySelector('.VarCol-filter-ductless:checked') !== null;
    const outdoorsSelected = document.querySelector('.VarCol-filter-outdoors:checked') !== null;
    const fastShippingSelected = document.querySelector('.VarCol-filter-fast-shipping:checked') !== null;

    // Get all variant items
    const items = document.querySelectorAll('.VarCol-variant-collection-item');

    items.forEach(item => {
        const itemCFM = parseInt(item.getAttribute('data-cfm'), 10); // Parse CFM value as a number
        const itemDuctless = item.getAttribute('data-ductless'); // Ductless value of the variant
        const itemFinish = item.getAttribute('data-finish'); // Finish value of the variant
        const itemInventory = parseInt(item.getAttribute('data-inventory'), 10); // Inventory quantity

        // Determine if the item matches the selected CFM range
        const showByCFM = selectedCFMs.length === 0 || selectedCFMs.some(range => {
            if (range === "600-900") {
                return itemCFM >= 600 && itemCFM <= 900;
            }
            if (range === "900-1200") {
                return itemCFM > 900 && itemCFM <= 1200;
            }
            if (range === "1200+") {
                return itemCFM > 1200;
            }
            if (range === "Variable") {
                return itemCFM === null || isNaN(itemCFM);
            }
            return false;
        });

        // Determine visibility based on other filters
        const showByDuctless = !ductlessSelected || (itemDuctless === "Yes");
        const showByOutdoors = !outdoorsSelected || (itemFinish === "304 Stainless Steel");
        const showByFastShipping = !fastShippingSelected || (itemInventory >= 3);

        // Apply final visibility logic
        item.style.display = (showByCFM && showByDuctless && showByOutdoors && showByFastShipping) ? 'block' : 'none';
    });
}




// Call this function whenever filters are changed
document.querySelectorAll('.VarCol-filter-cfm, .VarCol-filter-ductless, .VarCol-filter-outdoors').forEach(input => {
    input.addEventListener('change', VarColApplyFilters);
});
// Ensure checkbox is toggled when the label or surrounding area is clicked
document.querySelectorAll('.VarCol-filter-label').forEach(label => {
    label.addEventListener('click', (e) => {
        const checkbox = label.querySelector('input[type="checkbox"]');
        if (checkbox) {
            // Toggle the checkbox state explicitly
            if (checkbox.checked) {
                checkbox.checked = false;
            } else {
                checkbox.checked = true;
            }

            // Trigger the change event to ensure filters are applied
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Prevent default label behavior (if any)
        e.preventDefault();
    });
});

// Initial call to apply filters on page load
document.addEventListener('DOMContentLoaded', VarColApplyFilters);


document.querySelectorAll('.VarCol-accordion-button').forEach(button => {
    button.addEventListener('click', () => {
        button.classList.toggle('open');
        const content = button.nextElementSibling;
        content.style.display = content.style.display === 'block' ? 'none' : 'block';
    });
});

function VarColApplySort() {
    const sortBy = document.getElementById('VarCol-sort-by').value;
    const grid = document.getElementById('VarCol-variant-collection-product-grid');
    const items = Array.from(grid.getElementsByClassName('VarCol-variant-collection-item'));

    items.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price);
        const priceB = parseFloat(b.dataset.price);
        return sortBy === 'price-low-to-high' ? priceA - priceB : priceB - priceA;
    });

    grid.innerHTML = '';
    items.forEach(item => grid.appendChild(item));
}
